import React from 'react';
import { TrendingUp, ShieldAlert, PiggyBank, HeartHandshake } from 'lucide-react';
const benefits = [{
  title: 'Retiro Libre de Impuestos',
  description: 'A diferencia de un 401(k) tradicional, el dinero que acumulas y retiras de tu IUL puede ser completamente libre de impuestos si se estructura correctamente.',
  icon: PiggyBank
}, {
  title: 'Protección Familiar Garantizada',
  description: 'Proporciona un beneficio por fallecimiento que asegura que tu familia mantenga su estilo de vida y pague deudas si llegaras a faltar.',
  icon: ShieldAlert
}, {
  title: 'Crecimiento sin Riesgo de Pérdida',
  description: 'Tu dinero crece basado en el mercado (como el S&P 500), pero está protegido contra caídas. Si el mercado baja, no pierdes tu capital.',
  icon: TrendingUp
}, {
  title: 'Beneficios en Vida',
  description: 'No tienes que fallecer para usarlo. Puedes acceder a los fondos en caso de enfermedades crónicas, críticas o terminales.',
  icon: HeartHandshake
}];
export function Benefits() {
  return <section id="beneficios" className="py-20 bg-brand-light" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-13">
            ¿Por qué el IUL es la herramienta financiera definitiva?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-14">
            El Seguro de Vida Universal Indexado (IUL) no es solo un seguro de
            vida, es un vehículo de acumulación de riqueza que los bancos y los
            ricos han usado por décadas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-15">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-16">
              <div className="w-14 h-14 bg-brand-green/10 rounded-lg flex items-center justify-center mb-6" data-id="element-17">
                <benefit.icon className="w-7 h-7 text-brand-green" data-id="element-18" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3" data-id="element-19">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-20">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}